import moment from 'moment'
import debounce from 'lodash/debounce'

import { receiveCredentials } from 'internal-components/src/redux/modules/authentication'
import { updateActivity } from 'internal-components/src/redux/modules/meta'
import { loadSignup } from 'internal-components/src/redux/modules/signup/actions'

import { rememberSignup } from './redux/modules/signupEdit/actions'

export function saveAuth(store, local) {
  let auth = store.getState().authentication

  store.subscribe(() => {
    const nextAuth = store.getState().authentication

    if (auth !== nextAuth) {
      local.set('infinite-auth', {
        hmac: nextAuth.get('hmac') ? nextAuth.get('hmac').toObject() : null,
        user: nextAuth.get('user') ? nextAuth.get('user').toObject() : null,
      })

      auth = nextAuth
    }
  })
}

export function saveSignups(store, local) {
  let knownSignups = store.getState().signupEdit.get('knownSignups')

  store.subscribe(() => {
    const nextSignups = store.getState().signupEdit.get('knownSignups')

    if (knownSignups !== nextSignups) {
      local.set('infinite-signups', nextSignups)

      knownSignups = nextSignups
    }
  })
}

export function authLoad(store, local) {
  const load = local.get('infinite-auth')

  if (load) {
    if (load.hmac && moment(load.hmac.expires).isAfter()) {
      store.dispatch(receiveCredentials(load.user, load.hmac))
    }
  }
}

export function loadKnownSignups(store, local) {
  const rememberedSignups = local.get('infinite-signups')

  if (rememberedSignups) {
    if (typeof rememberedSignups === 'object') {
      Object.keys(rememberedSignups).forEach(reference => {
        store.dispatch(rememberSignup(reference, rememberedSignups[reference]))
        store.dispatch(loadSignup(reference, rememberedSignups[reference]))
      })
    }
  }
}

export function activity(store, window) {
  const update = debounce(() => {
    store.dispatch(updateActivity(moment()))
  }, 5000)

  window.addEventListener('click', update)
  window.addEventListener('keypress', update)
  window.addEventListener('scroll', update)
  window.addEventListener('mousemove', update)
  update()
}



// WEBPACK FOOTER //
// ./src/utils.js